<script setup>
import {getCurrentInstance, onMounted, ref} from "vue";
  const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
  const { $axios } = getCurrentInstance().appContext.config.globalProperties;
  const footerData = ref({});
  const useFullLinks = ref([]);
  onMounted(()=>{
        $axios.get($endpoint.LoadFooter).then((resp_footer_data)=>{
          console.warn(resp_footer_data.data);
          footerData.value = resp_footer_data.data;
          useFullLinks.value = resp_footer_data?.data?.useFullLinks ?? [];
        })
      }
  );
</script>
<template>
  <!-- FOOTER -->
  <footer id="impx-footer" class="uk-padding uk-padding-remove-bottom">
<!--    <div class="uk-container">-->
      <div class="uk-flex uk-flex-between ">
        <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-2-3@m">
          <div class="impx-footer-logo uk-align-center uk-text-center">
            <!-- Footer Logo -->
            <img :src="footerData?.logo?.url??''" class="logo_img" alt="Logo">
            <!-- Footer Note -->
            <p class="uk-margin-bottom">{{footerData?.slogan ?? ''}}</p>
            <!-- Site Copyright -->
          </div>
        </div>
        <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-2-3@m">
          <div class="uk-align-center uk-text-center">
            <h4 class="text-white">Liens utiles</h4>
              <ul class="uk-grid uk-margin-medium-top">
                <li class="uk-link-text text-white " :key="index" v-for="(item, index) in useFullLinks" >
                <router-link class="uk-margin" :to="item.url">{{item.title}} </router-link>
                </li>
              </ul>
          </div>
        </div>

      </div>
      <div class="uk-flex uk-flex-center data-uk-grid text-white">
        <p class="impx-copyright">{{footerData?.copyright}} {{new Date().toLocaleDateString()}}</p>
      </div>
<!--    </div>-->
    <!-- Scroll to Top -->
    <a href="#top" class="to-top fa fa-arrow-up" data-uk-scroll></a>
    <!-- Scroll to Top End -->
  </footer>
  <!-- FOOTER END -->

</template>

<style scoped>
  .impx-copyright{
    font-family: 'Lato', Arial, sans-serif;
    font-weight: bold;
  }
</style>